import { useEffect, useRef } from "react";

export default function useScrollElementIntoHorizontalView(
  elementId: string | null
) {
  const scrollElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (elementId) {
      const element = document.getElementById(elementId);

      if (element && scrollElement.current) {
        // this centers the element in the scroll container manually
        // not using DOM api scrollIntoView because that scrolls the whole page
        scrollElement.current.scrollLeft =
          element.offsetLeft -
          scrollElement.current.clientWidth / 2 +
          element.clientWidth / 2;
      }
    }
  }, [elementId]);

  return scrollElement;
}
